/**
 * La page que l'utilisateur regarde, pour la faire reculer derrière une modale
 * en mode carte.
 *
 * ⚠️ Ce que ça remplace : six composants cherchaient encore
 * `document.querySelector('ion-tabs ion-router-outlet, ion-router-outlet')`.
 * Ces éléments n'existent plus depuis la sortie d'Ionic, la requête rendait
 * donc `null` et le `presenting-element` valait `undefined`. En silence :
 * AppSheet ouvre quand même sa carte, simplement rien ne recule derrière. Tous
 * les appelants qui comptaient sur ce repli avaient perdu l'effet.
 *
 * On vise la page de PREMIER niveau, sous `.app-root`, donc l'écran entier,
 * barre d'onglets comprise. C'est ce que fait iOS, et c'est déjà ce que
 * passent les appelants qui fournissent leur `presenting-element` à la main
 * (TabsPage donne le `$el` de sa propre AppPage). Viser la page routée
 * intérieure laisserait la barre d'onglets à taille réelle pendant que le
 * reste recule.
 */
export function presentingPageElement(): HTMLElement | undefined {
  return childByClass(document.querySelector('.app-root'), 'app-page') ?? undefined
}

/**
 * Premier enfant DIRECT portant cette classe. Un parcours plutôt qu'un
 * `:scope >` : même résultat, sans dépendre du support du sélecteur (jsdom le
 * refuse sur un élément détaché).
 */
export function childByClass(parent: Element | null, className: string): HTMLElement | null {
  if (!parent) return null
  for (const child of Array.from(parent.children)) {
    if (child.classList.contains(className)) return child as HTMLElement
  }
  return null
}
